/** 子 frame 名称枚举 */
enum FRAME_NAME {
    /** 内嵌页面 */
    HASH = 'hashframe',
    /** 合同签约页面 */
    CONTRACT = 'contractframe',
    /** IM 聊天 */
    IM = 'J-imframe',
    /** 服务大厅 */
    SERVICE_MALL = 'J-serviceMallFrame',
}

/** 根据子 frame 名字查找 frame */
const getFrameByName = (frameName: FRAME_NAME | string): Window | null => {
    return ((window.frames as any)[frameName] as Window | undefined) || null;
};

/** 向特定 frame 发送消息 */
const sendMessageToSubFrame = (targetFrameName: FRAME_NAME | string, message: any) => {
    if (!message.handlerType) {
        message.handlerType = 'fromPushMessage';
    }
    const targetFrame = getFrameByName(targetFrameName);

    if (targetFrame) {
        targetFrame.postMessage(JSON.stringify(message), '*');
    }
};

/** 是否受信任的 frame，受信任的 frame 可以调用主页面提供的通用能力 */
/** 对hashframe 的子frame 进行了受信 */
const isTrustedFrame = (source: any): boolean => {
    return (
        !!source &&
        (source === getFrameByName(FRAME_NAME.HASH) ||
            source === getFrameByName(FRAME_NAME.IM) ||
            source === getFrameByName(FRAME_NAME.CONTRACT) ||
            source === getFrameByName(FRAME_NAME.SERVICE_MALL) ||
            source.parent === getFrameByName(FRAME_NAME.HASH))
    );
};

export { FRAME_NAME, getFrameByName, sendMessageToSubFrame, isTrustedFrame };
